const digitalData = {  
    "visitorProfile": {},
    "pageInfo": {},
    "campaignInfo": {},
    "shoppingCartInfo": {},
    "errors": [],
    "filters": [],
    "searches": [],
    "videosDisplayed": [],
    "devicesDisplayed": [],
    "plansDisplayed": [],
    "featuresDisplayed": [],
    "productsDisplayed": [],
    "events": []
}; 

export default digitalData;

 